import { SimpleCoffeeMark } from './SimpleCoffeeMark';
import './Logo.css';

export interface LogoProps {
  /** `full` shows mark + wordmark; `mark` shows the icon alone. */
  variant?: 'full' | 'mark';
  size?: number;
  /** Show the product tagline under the wordmark. */
  withTagline?: boolean;
}

export function Logo({ variant = 'full', size = 40, withTagline = false }: LogoProps) {
  if (variant === 'mark') {
    return <SimpleCoffeeMark size={size} />;
  }

  return (
    <span className="sc-logo">
      <SimpleCoffeeMark size={size} title={null} />
      <span className="sc-logo__text">
        <span className="sc-logo__wordmark">
          Simple<span className="sc-logo__wordmark-accent">Coffee</span>
        </span>
        {withTagline && (
          <span className="sc-logo__tagline">A simple coffee. A clear mind. A great analysis.</span>
        )}
      </span>
    </span>
  );
}
